module.exports = __webpack_public_path__ + "img/maternity.8afe10b9.png";